<template>
  <b-card class="rounded-lg">
    <report-header
      :title="$t('ledger_rep_sub_balances')"
      :scope-label="scopeLabel"
      :can-company="canCompany"
      :company="company"
      @company="company = $event; load()"
      @print="printReport"
    />
    <div class="d-flex flex-wrap mb-1">
      <b-form-input
        v-model="asOf"
        type="date"
        class="mr-50 mb-50 ledger-report-date"
      />
      <b-button
        size="sm"
        variant="primary"
        @click="load"
      >
        {{ $t('ledger_assets_load') }}
      </b-button>
    </div>
    <div
      v-if="loading"
      class="text-center py-3"
    >
      <b-spinner />
    </div>
    <template v-else-if="report">
      <div class="d-none d-md-block">
        <b-table
          :items="report.subcontractors || []"
          :fields="fields"
          small
          responsive
          class="ledger-dense-table"
        >
          <template #cell(name)="data">
            <b-link
              v-if="hasPermission('view subcontractors')"
              :to="{ name: 'ledger-subcontractors-view', params: { id: data.item.subcontractor_id } }"
            >
              {{ data.item.name }}
            </b-link>
            <span v-else>{{ data.item.name }}</span>
          </template>
          <template #cell(payable)="data"><span class="ledger-num">{{ money(data.item.payable) }}</span></template>
          <template #cell(retention)="data"><span class="ledger-num">{{ money(data.item.retention) }}</span></template>
          <template #cell(total)="data"><span class="ledger-num">{{ money(data.item.total) }}</span></template>
        </b-table>
      </div>
      <div class="d-md-none">
        <article
          v-for="row in report.subcontractors || []"
          :key="row.subcontractor_id"
          class="ledger-report-card"
        >
          <div>{{ row.name }}</div>
          <div class="ledger-num">
            {{ money(row.total) }}
          </div>
        </article>
      </div>
      <div
        v-if="report.totals"
        class="ledger-num mt-1"
      >
        {{ $t('ledger_assets_total') }} {{ money(report.totals.total) }}
      </div>
    </template>
  </b-card>
</template>

<script>
import {
  BCard, BFormInput, BButton, BSpinner, BTable, BLink,
} from 'bootstrap-vue'
import { getSubcontractorBalances } from '@/api/accounting/financialReports'
import { oneFrom } from '@/utils/ledger'
import ReportHeader from './ReportHeader.vue'
import reportMixin from './reportMixin'

export default {
  name: 'SubcontractorBalancesReport',
  components: {
    BCard, BFormInput, BButton, BSpinner, BTable, BLink, ReportHeader,
  },
  mixins: [reportMixin],
  computed: {
    fields() {
      return [
        { key: 'name', label: this.$t('ledger_sub_name') },
        { key: 'specialty', label: this.$t('ledger_sub_specialty') },
        { key: 'payable', label: this.$t('ledger_sub_payable') },
        { key: 'retention', label: this.$t('ledger_sub_retention') },
        { key: 'total', label: this.$t('ledger_assets_total') },
      ]
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await getSubcontractorBalances({ as_of: this.asOf, ...this.scopeParams })
        this.report = oneFrom(res)
      } catch (error) {
        this.toastError(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.ledger-num { font-variant-numeric: tabular-nums; }
.ledger-report-date { max-width: 11rem; }
.ledger-report-card { border-bottom: 1px solid #eee; padding: 0.75rem 0; }
</style>
